import { useState, useEffect } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import microApp from '@micro-zoe/micro-app'
import { Loading } from 'mk-pc'
import { lazily, getNavFirstPath } from '@mkmp/core'
import { useAuth } from '@/hooks'
import { useAppStore } from '@/stores'
import BasicLayout from '@/features/layout/BasicLayout'
import { Login } from '@/features/auth'
import { createModuleRoutes, createMicroAppRoutes } from './routes'

const { MessageMain } = lazily(() => import('@/features/message'))
const { NotFound } = lazily(() => import('@/features/common'))

/**
 * 创建router
 */
const router = createBrowserRouter([
  { path: '/', element: <BasicLayout />, children: [] },
  { path: '/login', handle: { name: 'title' }, element: <Login /> },
  { path: '/message', element: <MessageMain /> },
  { path: '*', Component: NotFound }
])

/**
 * 创建路由
 * @returns
 */
const useRouter = () => {
  const [loading, setLoading] = useState(true)
  const auth = useAuth()
  const { initData } = useAppStore()

  useEffect(() => {
    if (!auth.isAuthenticated) {
      const { pathname } = window.location

      setLoading(false)
      if (pathname !== '/login') {
        return window.location.replace(`/login?redirect=${encodeURIComponent(pathname)}`)
      }

      return
    }

    initData().then(() => {
      const moduleRoutes = createModuleRoutes()
      const appRoutes = createMicroAppRoutes()
      router.routes[0].children = moduleRoutes.concat(appRoutes)

      // 注册主应用路由
      microApp.router.setBaseAppRouter(router)

      const { pathname, search } = window.location
      if (pathname === '/') {
        router.navigate(getNavFirstPath(), { replace: true })
        // 固定默认首页
        // router.navigate(`/kbs/cloud/plan`, { replace: true })
      } else {
        // replace当前路由，为了触发路由匹配
        router.navigate(`${pathname}${search}`, { replace: true })
      }

      setLoading(false)
    })
  }, [])

  if (loading) {
    return <Loading />
  }

  return <RouterProvider router={router} />
}

export default useRouter
